import { render, staticRenderFns } from "./PlanIcon.vue?vue&type=template&id=58c43f84&"
import script from "./PlanIcon.vue?vue&type=script&lang=ts&"
export * from "./PlanIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports